import React, { useEffect } from 'react'
import { ResponsiveImage } from '../../components';
import css from './ListingPage.module.css';

const ListingImgSwiper = props => {
  const {
    allImages,
  } = props;

  useEffect(() => {
    // Initialize Swiper
    setTimeout(function() {
      new Swiper('.listingImg-swiper-container', {
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
        },
        on: {
          init: function () {
            // Set total slides once on init
            const totalSlides = this.slides.length;
            const currentIndex = this.realIndex + 1;
            document.querySelector('.custom-slide-counter').textContent = `${currentIndex}/${totalSlides}`;
          },
          slideChange: function () {
            const totalSlides = this.slides.length;
            const currentIndex = this.realIndex + 1;
            document.querySelector('.custom-slide-counter').textContent = `${currentIndex}/${totalSlides}`;
          }
        }
      });
      // Emit 'init' manually to trigger counter update on load
      swiperInstance.emit('init');
    }, 500);
  }, []);

  return (
    <div className="listingImg-swiper-container" data="listingImg-swiper-container">
      <div className="swiper-wrapper" data="listingImg-swiper">
        {allImages.map((images, index) => (
          <div className="swiper-slide" key={index} data="img-swiper-slide">
            <ResponsiveImage
                rootClassName={css.rootForImage}
                alt={`Image ${index + 1}`}
                image={images}
                variants={Object.keys(images?.attributes?.variants).filter(k => k.startsWith('scaled'))}
              />
          </div>
        ))}
      </div>
      {/*pagination dots*/}
      <div class="swiper-pagination" data="data-pagination"></div>
      {/*pagination dots*/}
      {allImages.length > 1 && 
        <div class="custom-slide-counter">1/<span class="totalCount">0</span></div>
      }
      
    </div>
  )
}
export default ListingImgSwiper;

